/**
 * Returns a Base64-encoded string that is safe to embed in URLs.
 *
 * According to the spec, a Base64-encoded string that's safe for use in URLs:
 *   * Has the `+` character replaced with `-`.
 *   * Has the `/` character replaced with `_`.
 *   * Has the trailing/padding `=` dropped.
 */
export function base64UrlEncode(val: string): string {
  return btoa(val).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

/** Returns the decoded URL-safe base64-encoded string that is safe to embed in URLs. */

/**
 * Decodes a string of URL-safe, Base64-encoded data into bytes, and encodes those bytesinto a
 * string using Latin-1 (ISO-8859-1).
 *
 * The input data is typically encoded with a `base64UrlEncode` method.
 * @param val The URL-safe, Base64-encoded input string.
 * @returns The decoded string
 */
// eslint-disable-next-line import/no-unused-modules
export function base64UrlDecode(val: string): string {
  return atob(val.replace(/-/g, '+').replace(/_/g, '/'));
}
